import { 
	Component, 
	ElementRef, 
	OnDestroy, 
	ViewEncapsulation 
} from "@angular/core";
import { SelectListCellRenderer } from "@cv-invision/core";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
// Model
import { URLS } from "../../models/partial-integration.model";
// Other
import { ICellRendererParams } from "ag-grid-community";

@Component({
	selector: 'cv-custom-partial-orders-action-grid-cell',
	templateUrl: './custom-action-grid-cell.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./custom-action-grid-cell.component.scss']
})
export class CustomActionPartialOrdersCellComponent extends SelectListCellRenderer implements OnDestroy {
    private atComponentDestroy: Subject<any> = new Subject<any>();
	public params: ICellRendererParams;
    public cellValue: any;
	public currentUrl: string;

    constructor(
        public elementRef: ElementRef,
		private router: Router,
    ) {
        super(elementRef);
    }

    /**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.params = params;
		this.cellValue = params.data;
	}

    /**
	 * Open selected log
	 * @param $event
	 */
	onViewLog(): void {
		let url = '';
		switch (true) {
			case  this.router.url.includes(URLS.RELIANCE_FIRST):
				url = `/global-configuration/reliance-first/logs/${this.cellValue.id}`;
				break;
			case  this.router.url.includes(URLS.MI_MUTUAL):
				url = `/global-configuration/mi-mutual/logs/${this.cellValue.id}`;
				break;
		}

		this.router.navigate([url],{ state: {id: this.cellValue.id}});	
	}
    
    ngOnDestroy(): void {
        this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
    }
}